module.exports = __webpack_public_path__ + "img/zhuanhuan.4315257b.svg";